module.exports = __webpack_public_path__ + "img/img-baseball-d.117f768d.png";